"use client";

// Sonner's Toaster subscribes to a singleton toast store via
// `useSyncExternalStore` plus a useEffect-based subscribe. Under React
// 19 / Next.js 15, the initial mount can race with concurrent commits
// and triggers "Cannot update a component (ForwardRef) while rendering
// a different component (ForwardRef)" — even with a setState-after-
// timeout(0) mounted guard, because the state flip still batches into
// AppLayout's commit cycle.
//
// The canonical fix is `next/dynamic` with `ssr: false`. That mounts
// SonnerToaster as a separately-code-split chunk through Suspense, so
// React enters a fresh commit phase for it. Nothing in the layout's
// initial render cycle can interleave with Sonner's store subscribe.

import dynamic from "next/dynamic";

const DynamicSonnerToaster = dynamic(
  () => import("sonner").then((m) => m.Toaster),
  {
    ssr: false,
    loading: () => null,
  },
);

export function Toaster() {
  return (
    <DynamicSonnerToaster
      richColors
      closeButton
      position="bottom-right"
    />
  );
}
